export enum ETypeStatus {
  ExamStatus = 'exam_status',
  BookingStatus = '',
  PaymentStatus = 'payment_status'
}
